// extracted by mini-css-extract-plugin
export default {"wrapper":"ganttChart_wrapper__Z7yMX"};